<div *ngIf="!commonService.isMobile" class="">
    <app-address-info [walletAddress]="address"></app-address-info>

    <div class="divider mt-10 mb-6"></div>

    <app-address-asset-transaction [walletAddress]="address" [pageType]="'address'" [walletProfile]="walletProfile"></app-address-asset-transaction>

    <div class="divider my-10"></div>

    <app-people-you-may-know></app-people-you-may-know>
</div>

<div *ngIf="commonService.isMobile">
    <app-address-info-mobile [walletAddress]="address"></app-address-info-mobile>

    <div class="divider my-6"></div>

    <app-address-asset-transaction [walletAddress]="address" [pageType]="'address'" [walletProfile]="walletProfile"></app-address-asset-transaction>

    <div class="divider my-6"></div>

    <app-people-you-may-know></app-people-you-may-know>
</div>
